import React from "react";

export default class RegisterSmile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
      errorPassword: null,
      password: "",
    };

    this.handleToggleShowPassword = this.handleToggleShowPassword.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleToggleShowPassword() {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  }

  validateForm() {
    const { password } = this.state;

    if (!password) {
      this.setState({ errorPassword: "Password harus diisi" });
      return false;
    } else {
      this.setState({ errorPassword: "" });
    }

    return true;
  }

  handleSubmit(e) {
    e.preventDefault();
    const { password } = this.state;

    if (!this.validateForm()) {
      return false;
    }

    this.props.onSubmit({ password_smile: password }, e);
  }

  render() {
    const { showPassword, errorPassword } = this.state;
    const { username_smile } = this.props;

    return (
      <form className="form-auth bg-white" onSubmit={this.handleSubmit}>
        <div>
          Silakan masukkan password untuk akun SMILE <b>{username_smile}</b>
        </div>
        <div className="input-field">
          <input
            name="password"
            type={!showPassword ? "password" : "text"}
            onChange={(e) => this.setState({ password: e.target.value })}
          />
          <i
            id="password"
            className="btn-show-hide-password material-icons"
            onClick={this.handleToggleShowPassword}
          >
            {showPassword ? "visibility_off" : "visibility"}
          </i>
          {errorPassword ? (
            <div className="red-text text-darken-2 font-tiny">
              {errorPassword}
            </div>
          ) : null}
        </div>

        <div className="form-auth__button-group mt-s">
          <button className="btn full mb-s" type="submit">
            Daftar
          </button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/components/RegisterPasswordSmile.js